









import { PDP } from '../lib/mixins';

export default {
  name: 'PdtNotFound',
  mixins: [PDP],
};
